<template>
  <div class="faqDetail">
    <div ref="detailContainer" class="detailContainer">
      <div class="title">{{detail.label}}</div>
      <div class="part" v-for="(item, index) in detailList[detail.key]" :key="index">
        <div class="subTitle">{{item.subTitle}}</div>
        <div class="content" v-html="item.content"></div>
      </div>
      <div class="bottomLogo">
        <img :src="logo" alt="">
      </div>
    </div>
  </div>

</template>

<script>
import logo from '@/assets/images/common/logo1.svg'

export default {
  name: 'faqDetail',
  props: ['detail'],
  data () {
    return {
      logo,
      detailList: this.$t('lang.faqDetailList')
    }
  },
  watch: {
    detail: { // 深度监听，可监听到对象、数组的变化
      handler () {
        this.$refs.detailContainer.scrollTop = 0
      },
      deep: true // true 深度监听
    }
  }
}
</script>

<style lang="less" scoped>
  .faqDetail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .detailContainer {
      height: 100%;
      padding-right: 10px;
      overflow: auto;
      .title {
        font-size: 22px;
        line-height: 26px;
        color: #F6D9AA;
        font-weight: bold;
        margin-bottom: 30px;
      }
      .part {
        margin-bottom: 30px;
        .subTitle {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
          margin-bottom: 20px;
        }
        .content {
          font-size: 16px;
          line-height: 19px;
          color: #fff;
          .mb10 {
            margin-bottom: 10px;
          }
          .ml15 {
            margin-left: 15px;
            display: flex;
          }
          .mt10 {
            margin-top: 10px;
          }
          .m10 {
            margin: 10px 0;
          }
        }
      }
      .bottomLogo {
        text-align: right;
        img {
          width: 40px;
        }
      }
      &::-webkit-scrollbar {
        width: 1px;
        height: 100%;
      }
      &::-webkit-scrollbar-track {
        width: 1px;
        height: 100%;
        background-color: transparent;
        border-radius: 33px;
      } /* 滚动条的滑轨背景颜色 */
      &::-webkit-scrollbar-thumb {
        width: 1px;
        border-radius: 33px;
        background-color: #F6D9AA;
      } /* 滑块颜色 */
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FAQ/children/FAQdetail.vue